// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/2281
import type { PAPEventGeneric } from "../base/event";
import type { SignatureTab } from "../enums/signature_tab";
import type { SignatureActionFlow } from "../enums/signature_action_flow";
import type { DashExperience } from "../enums/dash_experience";
import type { UpsellFeature } from "../enums/upsell_feature";
import type { UpsellFormat } from "../enums/upsell_format";
import type { CtaName } from "../enums/cta_name";
import type { DashWriteTemplate } from "../enums/dash_write_template";

// Event_name: 'select.upsell'
// Description: User selects an upsell CTA on the Signatures page
// Owner: hellosign-synergies
export type Select_Upsell = PAPEventGeneric<
  'sign',
  'select',
  'upsell',
  {
    // Denotes which tab is selected in signature hub
    signatureTab?: SignatureTab;
    // Denotes some type of signature action flow
    signatureActionFlow?: SignatureActionFlow;
    // The property used to distinguish fss dash and dash standalone features
    dashExperience?: DashExperience;
    // which feature is being featured in the upsell
    upsellFeature?: UpsellFeature;
    // what form the upsell took
    upsellFormat?: UpsellFormat;
    // Name of the 'Call to Action'
    ctaName?: CtaName;
    // The display name of a dash connector
    dashConnectorDisplayName?: string;
    // The module the user will select from the Action Screen in order to perform the action. i.e. quick_actions_empty_state, quick_actions_header
    // **NOTE: you must update the allowlist if you're using this for a new value: https://dropbox.atlassian.net/wiki/spaces/PAP/pages/1093468269/Action+Element+Sanitization
    actionElement?: string;
    // For promotions in FSS to Dash, we want to have CTAs that allow users to open Dash write experience using a certain template (eg. Write Status report, Write Marketing blog post, etc). This property tracks which templates are being used.
    // https://www.dropbox.com/scl/fi/1iqbpqfgfjbylsjhebbeh/PRD-FSS-Dash-Standalone.paper?rlkey=kyjc21kocbpxtl37s6n6rajxg&dl=0
    dashWriteTemplate?: DashWriteTemplate;
  }
>;

export function PAP_Select_Upsell(properties?: Select_Upsell['properties']): Select_Upsell {
  return <Select_Upsell>{
    class: 'sign',
    action: 'select',
    object: 'upsell',
    properties,
  };
}
